<template>
  <vx-card v-show="isCardActiveLocal" class="mt-3 mb-4" title="Final Summary">
    <div class="vx-row">
      <div class="flex flex-wrap items-center justify-center">
        <p class="ml-4 mr-2">Final Score: </p>
        <p><strong>{{ captureTask.achievedMarks + " / " + captureTask.totalMarks }}</strong></p>
      </div>
    </div>
    <div v-if="captureTask.assessorComment" class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label><strong>Assessor Comment:</strong></label>
        <vs-textarea readOnly v-model="captureTask.assessorComment" />
      </div>
    </div>
    <div class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label>Your Comment:</label>
        <vs-textarea v-model="captureTask.studentComment" />
      </div>
    </div>
  </vx-card>
</template>

<script>
  import vSelect from 'vue-select'
  export default {
    components: {
      'v-select': vSelect
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      captureTask: {
        type: Object,
        required: false
      }
    },
    data() {
      return {
        
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          
        }
      }
    },
    mounted() {
      
    },
  }

</script>

<style lang="scss">

</style>
